export const mobileMenuIconClickHandler = () => {
  return (dispatch, getState) => {
    dispatch({ type: 'MOBILE_MENU_ICON_CLICKED' });
  }
}